/**
 * @author Sambit Ekka <sambit.ekka@314ecorp.com>
 * @description Chat Icon
 */

import React from 'react';
import clsx from 'clsx';

const ChatIcon = (props: any): React.JSX.Element => {
	const { size = 14, className, iconColor = 'black', ...restProps } = props;
	const cn = clsx('anticon anticon-icon', className);

	return (
		<svg className={cn} {...restProps} width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_19749_121239)'>
				<path
					d='M8.74967 2.33331C8.74967 2.1786 8.68817 2.03027 8.57878 1.92088C8.46938 1.81148 8.32105 1.74998 8.16634 1.74998H2.33301C2.1783 1.74998 2.02997 1.81148 1.92057 1.92088C1.81118 2.03027 1.74967 2.1786 1.74967 2.33331V7.92511L2.74544 6.92934L2.87362 6.81313C3.18496 6.55795 3.57666 6.41673 3.98275 6.41665H8.16634C8.32105 6.41665 8.46938 6.35514 8.57878 6.24575C8.68817 6.13635 8.74967 5.98802 8.74967 5.83331V2.33331ZM9.91634 5.83331C9.91634 6.29744 9.73183 6.74243 9.40365 7.07062C9.07546 7.39881 8.63047 7.58331 8.16634 7.58331H3.98275C3.82807 7.58336 3.67967 7.64482 3.57031 7.75421L2.28573 9.0388C2.14628 9.17821 1.96869 9.27316 1.77531 9.31167C1.58187 9.35014 1.38104 9.33072 1.19881 9.25527C1.01658 9.17979 0.860664 9.05182 0.751058 8.88784C0.655109 8.74426 0.598539 8.57843 0.585856 8.40704L0.583008 8.33356V2.33331C0.583008 1.86918 0.767514 1.4242 1.0957 1.09601C1.42389 0.76782 1.86888 0.583313 2.33301 0.583313H8.16634C8.63047 0.583313 9.07546 0.76782 9.40365 1.09601C9.73183 1.4242 9.91634 1.86918 9.91634 2.33331V5.83331Z'
					fill={iconColor}
					fillOpacity='0.65'
				/>
				<path
					d='M13.4135 12.4904C13.4008 12.6618 13.3442 12.8276 13.2483 12.9712C13.1387 13.1352 12.9828 13.2632 12.8005 13.3386C12.6183 13.4141 12.4175 13.4335 12.224 13.395C12.0548 13.3613 11.8978 13.2844 11.7677 13.1723L11.7136 13.1222L10.429 11.8376C10.3333 11.7418 10.2077 11.6828 10.0741 11.6695L10.0166 11.6667H5.83301C5.36888 11.6667 4.92389 11.4822 4.5957 11.154C4.26751 10.8258 4.08301 10.3808 4.08301 9.91669V9.33335C4.08301 9.01119 4.34418 8.75002 4.66634 8.75002C4.98851 8.75002 5.24967 9.01119 5.24967 9.33335V9.91669C5.24967 10.0714 5.31118 10.2197 5.42057 10.3291C5.52997 10.4385 5.6783 10.5 5.83301 10.5H10.0166C10.4806 10.5001 10.9258 10.6846 11.2539 11.0127L12.2497 12.0085V6.41669C12.2497 6.26198 12.1882 6.11365 12.0788 6.00425C11.9694 5.89486 11.8211 5.83335 11.6663 5.83335C11.3442 5.83335 11.083 5.57219 11.083 5.25002C11.083 4.92785 11.3442 4.66669 11.6663 4.66669C12.1305 4.66669 12.5755 4.85119 12.9036 5.17938C13.2318 5.50757 13.4163 5.95256 13.4163 6.41669V12.4169L13.4135 12.4904Z'
					fill={iconColor}
					fillOpacity='0.65'
				/>
			</g>
			<defs>
				<clipPath id='clip0_19749_121239'>
					<rect width='14' height='14' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default ChatIcon;
